/* eslint-disable react/no-array-index-key */
import { useState, useRef, useEffect } from "react";
import { Box, Table, Text } from "@quintoandar-tokko/jopijs";
import { useSelector } from "react-redux";
import style from "../fichaInfo.module.scss";
import Trans from "@/components/shared/Trans";
import translations from "../FichaInfo.trans.json";
import { chunkArray } from "@/components/shared/Hooks";

export default function Temporary() {
  const { origin_data, isEdition, edited_data, showData, loading } =
    useSelector((state) => state.FichaInfoSlice);
  const { temporary, on_web_price } = origin_data;
  const { show_operation_temporary_rent } = edited_data;
  const [showMore, setShowMore] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const tableRef = useRef();
  const toggle = () => setShowMore((prev) => !prev);

  useEffect(() => {
    if (
      loading ||
      !temporary ||
      temporary.periods.length === 0 ||
      (!isEdition &&
        showData === "edited_data" &&
        !show_operation_temporary_rent)
    ) {
      return;
    }
    const tableElement = tableRef.current;
    const tableTotalHeigth = document.getElementById("tableBody")?.clientHeight;
    if (tableElement) {
      setIsOverflowing(tableTotalHeigth > 400);
    }
  }, [edited_data, showData]);

  useEffect(() => {
    if (!temporary || temporary.periods.length === 0) {
      return;
    }
    setTimeout(() => {
      if (!showMore && isOverflowing) {
        tableRef.current?.classList.add(style.clamp);
      } else {
        tableRef.current?.classList.remove(style.clamp);
      }
    }, 300);
  }, [showMore, isOverflowing]);

  if (
    loading ||
    !origin_data.temporary || !on_web_price ||
    origin_data.temporary.periods.length === 0
  ) {
    return null;
  }

  const Columns = [Trans(translations, "Period"), ...temporary.currencies];

  const handlePeriods = () => {
    const newArray = [];

    for (let index = 0; index < temporary.periods.length; index++) {
      const element = [];

      for (let i = 0; i < temporary.periods[index].length; i++) {
        if (i === 0) {
          element.push(temporary.periods[index][i]);
        } else {
          let value;
          if (temporary.periods[index].length !== Columns.length) {
            value = temporary.periods[index][i].includes(Columns[i].slice(-3))
              ? [temporary.periods[index][i], ""]
              : ["", temporary.periods[index][i]];
          } else {
            value = [temporary.periods[index][i]];
          }

          element.push(...value);
        }
      }
      newArray.push(element);
    }
    return newArray;
  };
  if (
    !isEdition &&
    showData === "edited_data" &&
    !show_operation_temporary_rent
  )
    return;

  const additionalData = temporary.additional_data
    ? chunkArray(temporary.additional_data, 3)
    : [];
  
  return (
    <Box>
      <Text className={style.BITitle} variant="bodyBold.fontSize14">
        {Trans(translations, 'TemporaryRent')}
      </Text>

      {additionalData.length > 0 && (
          <Box className={style.infoCont}>
          {additionalData.map((column, columnIndex) => (
            <Box key={columnIndex + 1} className={style.BIItems}>
              {column.map(
                (item, index) =>
                  item.name && (
                    <Text key={index} variant="body.fontSize14">
                      {item.name}: {item.value}
                    </Text>
                  )
              )}
            </Box>
          ))}
        </Box>
      )}

      <Box
        __css={{
          maxHeight: showMore ? `${tableRef.current.scrollHeight}px` : "430px",
          overflow: "hidden",
        }}
        className={`${style.boxStyle} ${showMore ? style.show : ""} ${
          isEdition && style.opacity
        }`}
        ref={tableRef}
      >
        <Table>
          <Table.Header
            __css={{
              padding: "19px 24px",
            }}
          >
            {Columns.map((column, ci) => (
              <Table.HeaderItemDefault key={`Col${ci}`}>
                <Text variant="bodyBold.fontSize14">{column}</Text>
              </Table.HeaderItemDefault>
            ))}
          </Table.Header>
          <Table.Rows id="tableBody">
            {handlePeriods().map((row, ri) => (
              <Table.RowDefault id={ri} key={`Row${ri}`} variant="minimalist">
                {row.map((item, rowsi) => (
                  <Table.RowItemDefault
                    className="tableRow"
                    id="tableRow"
                    key={`RowItem${rowsi}`}
                  >
                    <Text variant="body.fontSize14">{item}</Text>
                  </Table.RowItemDefault>
                ))}
              </Table.RowDefault>
            ))}
          </Table.Rows>
        </Table>
      </Box>
      {isOverflowing && (
        <Box
          as="span"
          className={`${style.actionBtn} ${isEdition ? style.opacity : ""}`}
          onClick={toggle}
        >
          {showMore
            ? Trans(translations, "ShowLess")
            : Trans(translations, "ShowMore")}
        </Box>
      )}
    </Box>
  );
}
